<template>
  <div class="side-menu">
    <div
      class="logo-wrap"
      :class="{ collapse: collapse }"
      @transitionend="onTransitionend"
    >
      <div class="logo">
        <el-image :src="require('../../assets/img/logo.png')" />
      </div>
      <div class="collapse-btn" @click="handleCollapse">
        <i :class="toggleIconClass" />
      </div>
    </div>
    <el-scrollbar>
      <el-menu
        :default-active="activePath"
        :collapse="collapse"
        router
        background-color="#333333"
        text-color="#CFD1D8"
        active-text-color="#FFFFFF"
        :collapse-transition="false"
      >
        <template v-for="(menu, i) in menus">
          <el-submenu
            v-if="menu.subMenus"
            :key="`sub_menu_${i}`"
            :index="menu.url"
            :style="menuItemStyle"
          >
            <template slot="title">
              <i :class="`iconfont ${menu.icon}`"></i>
              <span slot="title" v-text="menu.name" />
            </template>
            <template v-for="(subMenu, j) in menu.subMenus">
              <el-menu-item :key="`sub_menu_item${j}`" :index="subMenu.url">
                {{ subMenu.name }}
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item
            v-else
            :index="menu.url"
            :style="menuItemStyle"
            :key="`menu_${i}`"
          >
            <i :class="`iconfont ${menu.icon}`"></i>
            <span slot="title" v-text="menu.name" />
          </el-menu-item>
        </template>
      </el-menu>
       <!-- <button class="ai-msl" type="button"> Log in</button> -->
       <!-- <i class="el-icon-thumb" style="padding-right: 10px;"></i> -->
      <button class="ai-msl" @click="openAIMSL"><i class="icon ion-md-lock"></i><i class="el-icon-thumb" style="padding-right: 10px;"></i>LIMI</button>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "SideMenu",
  data() {
    return {
      width: 64,
    };
  },
  computed: {
    menus() {
      return this.$store.state.menus || [];
    },
    collapse() {
      return this.$store.state.sideMenuCollapse;
    },
    activePath() {
      let path = this.$route.path;
      var menu = this.menus.find((i) => {
        if (i.subMenus) {
          menu = i.subMenus.find((j) => {
            return j.url === path || path.indexOf(j.url) === 0;
          });
        } else {
          return i.url === path || path.indexOf(i.url) === 0;
        }
      });
      return menu ? menu.url : path;
    },
    toggleIconClass() {
      return `iconfont ${this.collapse ? "icon-menu-open" : "icon-menu-close"}`;
    },
    menuItemStyle() {
      return `width:${this.width}px`;
    },
  },
  watch: {
    collapse(value) {
      if (!value) {
        this.setWidth(value);
      }
    },
  },
  created() {
    this.$store.commit("updateState", {
      sideMenuCollapse:
        !!this.isMobile() || (!this.isMobile() && this.collapse),
    });
    this.setWidth(this.collapse);
  },
  methods: {
    handleCollapse() {
      this.$store.commit("updateState", {
        sideMenuCollapse: !this.collapse,
      });
      this.bus.$emit("onSideMenuCollapse", this.collapse);
    },
    onTransitionend() {
      if (this.collapse) {
        this.setWidth(this.collapse);
      }
    },
    setWidth(value) {
      if (value) {
        this.width = 64;
      } else {
        this.width = 280;
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    openAIMSL() {
      this.axios
            .post("/sys/trackLinkClick", {
            })
           
      // 根据环境选择不同的URL
      const isProduction = process.env.NODE_ENV === 'production';
      const url = isProduction 
        ? 'https://aimsl-chatbot.lilly.cn/chatbot/page/chatbox' 
        : 'https://aimsl-chatbot.qa.lilly.cn/chatbot/page/chatbox';
      
      // 在新窗口打开URL
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.side-menu {
  background-color: $side-menu-bg-color;
  height: 100%;
  overflow: hidden;
  .logo-wrap {
    position: relative;
    height: 50px;
    background-color: $side-menu-bg-color;
    display: flex;
    overflow: hidden;
    line-height: 50px;
    width: $side-menu-width;
    transition: all 0.18s;
    &.collapse {
      width: 64px;
    }
    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 1;
      width: 100%;
      .el-image {
        width: 50px;
        height: 30px;
      }
    }

    .collapse-btn {
      background-color: $side-menu-bg-color;
      position: absolute;
      right: 0;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      color: #ffffff;
      padding: 0px 20px;
      font-size: 20px;
      width: 64px;
      .icon-menu-open {
        color: $theme-color !important;
      }
      i {
        margin: 0;
        vertical-align: middle;
        width: 24px;
        text-align: center;
      }
    }
  }
  .el-scrollbar {
    height: calc(100% - 50px - 50px);
    background-color: $side-menu-bg-color;
    overflow: hidden;
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    ::v-deep {
      .el-menu--collapse {
        .el-submenu.is-active > .el-submenu__title {
          i {
            color: #fff !important;
          }
          background-color: $theme-color !important;
        }
      }
      .el-submenu.is-active:not(.is-opened) > .el-submenu__title {
        i {
          color: #fff !important;
        }
        background-color: $theme-color !important;
      }
    }
    .el-menu {
      height: 100%;
      border: none !important;
      width: $side-menu-width;
      &.el-menu,
      .el-menu-item {
        padding-left: 0px;
        overflow: hidden;
        display: block;
        transition: all 0.18s !important;
      }
      .el-menu-item {
        & [class^="iconfont "] {
          margin-right: 10px;
          width: 24px;
          text-align: center;
          font-size: 20px;
          vertical-align: middle;
        }
        &.is-active {
          background-color: $theme-color !important;
          & > span {
            font-weight: bold;
          }
        }
      }
      [class^="iconfont "] {
        margin-right: 10px;
        width: 24px;
        text-align: center;
        font-size: 20px;
        vertical-align: middle;
      }
      &.is-active {
        background-color: $theme-color !important;
        & > span {
          font-weight: bold;
        }
      }
    }
    .el-submenu {
      ::v-deep .el-menu-item {
        padding-left: 50px !important;
      }
    }
  }
}
.ai-msl{
  position: fixed;
    bottom: 20px;
    left: 135px;
    color: #fff;
    font-size: 16px;
    transform: translateX(-50%);
        cursor: pointer;
}

$ruler: 16px;
$color-red: #fff;
$color-bg: #333333;
$color-shadow: #babecc;
$color-white: #fff;



button,
input {
  border: 0;
  outline: 0;
  border-radius: 20px;
      padding: 8px 15px;
      background-color: #414141;
      text-shadow: 1px 1px 0 #00000069;
}


button {
  color: #61677c;
  font-weight: bold;
  box-shadow: -5px -5px 13px #656565, 5px 5px 6px #000000;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  font-weight: 600;

  &:hover {
   box-shadow: 0px 0px 5px #ffffff, 0px 0px 5px #fbfafa;
  }

  &:active {
    box-shadow: inset 1px 1px 2px $color-shadow,
      inset -1px -1px 2px $color-white;
  }

  .icon {
    margin-right: $ruler/2;
  }


  &.red {
    display: block;
    width: 100%;
    color: $color-red;
  }
}
</style>
